import { createSignal } from '@funtech-int/rival';

export const isPlayingFromBeginningVar = createSignal(false);
